import { Injectable } from '@angular/core';
import { AutomationCredentialsService } from './automation-credentials.service';


@Injectable()
export class AutomationExporterService {

    constructor(private automationCredentialsService: AutomationCredentialsService) { }

    getExecutionContextDefaultCopyS3(inputMap: string,
        companyFolder: string,
        outputFolder: string,
        accessKeyId: string,
        secretAccessKey: string){
        let copy = Object.assign({}, this._getExecutionContextDefaultS3());

        this._updateExporterInputMap(copy, inputMap);
        this._updateExporterCompanyFolder(copy, companyFolder);
        this._updateExporterOutput(copy, outputFolder);
        this.automationCredentialsService.updateCredentialsS3(copy, accessKeyId, secretAccessKey);

        return copy;
    }

    getExecutionContextDefaultCopyHsbShare(inputMap: string,
        companyFolder: string,
        outputFolder: string,
        accessToken: string){
        let copy = Object.assign({}, this._getExecutionContextDefaultHsbShare());

        this._updateExporterInputMap(copy, inputMap);
        this._updateExporterCompanyFolder(copy, companyFolder);
        this._updateExporterOutput(copy, outputFolder);
        this.automationCredentialsService.updateCredentialsHsbShare(copy, accessToken);

        return copy;
    }


    updateCommandLineParameters(executionContext: any, 
        modeCLParam: string, 
        exportCLParam: string){

        let commandLineParameters = ['/company:"$(__config)\\Exporter\\Company\\ServerCompany"',
        '/output:"$(__config)\\Exporter\\TempData\\Output"',
        '/mode:'+modeCLParam,
        '/export:'+exportCLParam,
        '/silent',
        '/outputsummary',
        '$(ExporterInputMap)'
        ];
        executionContext.Activity.Instruction.CommandLineParameters = commandLineParameters;
    }


    private _updateExporterInputMap(executionContext, argumentValue){
        executionContext.WorkItem.Arguments.InputArguments.forEach(argument => {
            if(argument.Name === "ExporterInputMap"){
                argument.Resource = argumentValue;
            }
        });
    }
    private _updateExporterCompanyFolder(executionContext, argumentValue){
        executionContext.WorkItem.Arguments.InputArguments.forEach(argument => {
            if(argument.Name === "CompanyFolder"){
                argument.Resource = argumentValue;
            }
        });
    }
    private _updateExporterOutput(executionContext, argumentValue){
        executionContext.WorkItem.Arguments.OutputArguments.forEach(argument => {
            if(argument.Name === "ExporterOutput"){
                argument.Resource = argumentValue;
            }
        });
    }
    private _getExecutionContextDefaultS3(){
        let execContext: any = this._getDefaultWorkItemS3();
        execContext.Activity = this._getDefaultActivity().Activity;
        return execContext;
    }
    private _getExecutionContextDefaultHsbShare(){
        let execContext: any = this._getDefaultWorkItemHsbShare();
        execContext.Activity = this._getDefaultActivity().Activity;
        return execContext;
    }

    private _getDefaultActivity(){
        return  {
            "Activity": {
                "Id": "hsbExporterActivity",
                "HostApplication": "$(__applicationsRoot)/hsbcad/Default/Export/hsbExporter.exe",
                "Parameters": {
                    "InputParameters": [{
                        "Name": "ExporterInputMap",
                        "LocalFolderPath": "$(__config)/Exporter/TempData/Download/Input/ModelMap",
                        "LocalFileName": "all.hmm"
                    },{
                        "Name": "CompanyFolder",
                        "LocalFolderPath": "$(__config)/Exporter/TempData/Download/Input/Company",
                        "LocalFileName": "ServerCompany.zip",
                        "LocalFolderToUnzipTo": "$(__config)/Exporter/Company"
                    }],
                    "OutputParameters": [{
                        "Name": "ExporterOutput",
                        "LocalFolderToZip": "$(__config)/Exporter/TempData/Output",
                        "LocalFolderPath": "$(__config)/Exporter/TempData/Upload",
                        "LocalFileName": "OutputData.zip"
                    }]
                },
                "Instruction": {
                    "CommandLineParameters": ['/company:"$(__config)\\Exporter\\Company\\ServerCompany"','/output:"$(__config)\\Exporter\\TempData\\Output"','/mode:Group','/export:ServerGroup','/silent','/outputsummary','$(ExporterInputMap)']
                }
            }
        };   
    }


    private _getDefaultWorkItemS3() {
        return {
                "WorkItem": {
                "Id": "hsbExporterWorkItem",
                "ActivityId": "hsbExporterActivity",
                "Arguments": {
                    "InputArguments": [{
                        "Resource": "https://iohsbsharebucket.s3.amazonaws.com/Exporter/Input/all.hmm",
                        "Name": "ExporterInputMap",
                        "StorageProvider": "S3",
                        "Headers":[{
                            "Name":"AccessKeyId",
                            "Value":"AKIAIMVKNEIZGS4LP7KQ"
                        },{
                            "Name":"SecretAccessKey",
                            "Value":"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"
                        }]
                    },{
                        "Resource": "https://iohsbsharebucket.s3.amazonaws.com/MapTransform/mapIn/ServerCompany.zip",
                        "Name": "CompanyFolder",
                        "StorageProvider": "S3",
                        "Headers":[{
                            "Name":"AccessKeyId",
                            "Value":"AKIAIMVKNEIZGS4LP7KQ"
                        },{
                            "Name":"SecretAccessKey",
                            "Value":"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"
                        }]
                    }],
                    "OutputArguments": [{
                        "Resource": "https://iohsbsharebucket.s3.amazonaws.com/Exporter/Output/output.zip",
                        "Name": "ExporterOutput",
                        "StorageProvider": "S3",
                        "Headers":[{
                            "Name":"AccessKeyId",
                            "Value":"AKIAIMVKNEIZGS4LP7KQ"
                        },{
                            "Name":"SecretAccessKey",
                            "Value":"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"
                        }]
                    }]
                }
            }
        }
    }

    private _getDefaultWorkItemHsbShare() {
        return {
            "WorkItem": {
                "Id": "hsbExporterWorkItem",
                "ActivityId": "hsbExporterActivity",
                "Arguments": {
                    "InputArguments": [{
                        "Resource": "/projects/5622-6ad2-08b7-b382/Pack/Exporter/Input/all.hmm",
                        "Name": "ExporterInputMap",
                        "StorageProvider": "HsbShare",
                        "Headers":[{   
                            "Name":"AccessToken",
                            "Value": ''
                        }]
                    },{
                        "Resource": "/projects/5622-6ad2-08b7-b382/Pack/Exporter/Input/ServerCompany.zip",
                        "Name": "CompanyFolder",
                        "StorageProvider": "HsbShare",
                        "Headers":[{   
                            "Name":"AccessToken",
                            "Value": ''
                        }]
                    }],
                    "OutputArguments": [{
                        "Resource": "/projects/5622-6ad2-08b7-b382/Pack/Exporter/Output/output.zip",
                        "Name": "ExporterOutput",
                        "StorageProvider": "HsbShare",
                        "Headers":[{   
                            "Name":"AccessToken",
                            "Value": ''
                        }]
                    }]
                }
            }
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/automation-exporter.service.ts